import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { themeStructure } from "@bloglovin/vue-component-library";
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ButtonBorderWidth extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId) => {
    let suffix = "px";
    const selectOptions = [];

    if (themeId !== null) {
      themeStructure.size.border.map(size => {
        let pxValue = BaseOption._getStyleValuePropertiesFromTheme("size.border", themeId)[size];

        selectOptions.push({
          value: size,
          label: camelToTitleCase(size),
          secondaryLabel: pxValue,
        });
      });
    }

    return {
      label: "Border Width",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        showAllResultsOnClick: true,
        allowCustomValue: true,
        suffix: suffix,
        items: selectOptions,
        manualUpdate: true,
        findSuffix: modelValue => {
          if (!modelValue.secondaryLabel && themeStructure.size.border.includes(modelValue.value)) {
            return BaseOption._getStyleValuePropertiesFromTheme("size.border", themeId)[modelValue.value];
          }

          if (!modelValue.secondaryLabel) {
            return "px";
          }

          return modelValue.secondaryLabel;
        },
        sideEffect: (value, emitUpdate) => {
          if (Number.isFinite(parseInt(value.value))) {
            emitUpdate({ source: "custom", value: value.value });
            return;
          }

          const newValue = { source: "size.border", value: value.value };
          emitUpdate(newValue);
        },
      },
    };
  };

  static defaultValue = {
    value: "none",
    source: "theme.border",
  };

  static convertConfigValueToCompiledValue(configValue, themeId) {
    let optionValue = configValue;
    if (typeof optionValue === "object") {
      optionValue = configValue.value;
    }
    const value = BaseOption._getStyleValuePropertiesFromTheme("size.border", themeId)[optionValue];

    if (value) {
      return value;
    }

    if (Number.isFinite(optionValue)) {
      return optionValue + "px";
    }

    if (typeof configValue === "object" && configValue.source === "custom") {
      if (optionValue.toString().includes("px")) {
        return optionValue;
      }
      return optionValue + "px";
    }

    return optionValue;
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
